import client from '../client'
import { VendorInfo } from './types'

export interface GetVendorInfoResponse extends Response {
	data: { vendor_info: VendorInfo }
}

export const getVendorInfo = async (): Promise<GetVendorInfoResponse> => {
	const response = await client.get<GetVendorInfoResponse>('/vendors/info')

	return response.data
}
